import {HttpErrorResponse} from "@angular/common/http";
import {ErrorHandler, Injectable} from "@angular/core";
import {throwError} from "rxjs";

@Injectable({providedIn: 'root'})
export class ErrorHandlerService implements ErrorHandler {

    public handleError(error: HttpErrorResponse) {

        let errorMessage;

        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.log('A client-side or network error occurred:', error.error.message);
            errorMessage = error.error.message;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong
            if (error.error && error.error.message) {
                console.log(`[${error.status}] ${error.error.message}`);
                errorMessage = `[${error.status}] ${error.error.message}`;
                error = error.error;
            } else {
                console.log(`[${error.status}] ${error.message}`);
                errorMessage = `[${error.status}] L'opération n'a pas pu être effectuée`;
            }


            if (error.status === 500) {
                errorMessage = `Erreur interne du serveur [${error.status}]`;
            }
        }

        // return an observable with a user-facing error message
        console.log("ErrorHandlerService => propage:", errorMessage);
        return throwError(errorMessage);
    };

}
